import { ELECTION_ATTRIBUTE_NUMBERS } from '~/consts/elections';
import { JobPositionCityAttributeValueNumber } from '~/definitions/admin';
import { getStore } from '~/mobx/AppStore';

export const getElectionJobPositionCity = (): JobPositionCityAttributeValueNumber => {
    const adminStore = getStore().adminStore;

    const jobPositionCityAttrState = adminStore.attributesState.find(
        (attr) => attr.number === ELECTION_ATTRIBUTE_NUMBERS['election_job_position_city']
    );
    if (jobPositionCityAttrState) {
        return jobPositionCityAttrState?.options?.find((attr) => attr.valueId === jobPositionCityAttrState.value)
            ?.number as JobPositionCityAttributeValueNumber;
    } else {
        return '' as JobPositionCityAttributeValueNumber;
    }
};
